import { SelectOption } from '~/definitions/admin';
import { ElectionAttribute } from '~/definitions/election';
import { getStore } from '~/mobx/AppStore';

export const getAttributeValueFromOptions = (
    key: string,
    options: SelectOption[],
    attributes: ElectionAttribute[]
): string => {
    const { adminStore } = getStore();
    const selectedOptions = options.find((option) => {
        return option.value === adminStore.getAttributeValue(key, attributes);
    });
    return selectedOptions?.value || '';
};
